/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Table, Input, Select, Modal, Tooltip , Spin } from "antd";
import Map from "../../ui/map_full_detail";
import Api from "../../services/ServiceApi";
// import { css } from "emotion";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
// import reqwest from "reqwest";
import ModalSuccess from "../../components/Modal_Success";

function createJob(item, active) {
  localStorage.setItem("informDetail", JSON.stringify(item));
  localStorage.setItem("active", active);
  localStorage.setItem("StatusLocal", 2);
  setTimeout(function () {
    window.location.assign("/MaxiOperation/editjob");
  }, 1000);
}

// const { Option } = Select;
function setCookies(item, active) {
  localStorage.setItem("informDetail", JSON.stringify(item));
  localStorage.setItem("active", active);
  setTimeout(function () {
    window.location.assign("/MaxiOperation/inform_problem_detail");
  }, 1000);
}
class InformList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Inform Problem",
      tab: [
        { text: "Checking" },
        { text: "Approve Job" },
        { text: "Create Job" },
        { text: "Cancel" },
      ],
      active: 0,
      options: [
        { value: 1, text: "Job ID" },
        { value: 2, text: "Inform Date" },
      ],
      current_option: 1,
      columns: [
        {
          title: "Inform No.",
          key: "inform_job_no",
          render: (item) => (
            <a
              // href={null}
              className="c-blue text-underline"
              onClick={() => setCookies(item, this.state.active + 1)}
            >
              {item.inform_job_no}
            </a>
          ),
          sorter: (a, b) => a.inform_job_no.localeCompare(b.inform_job_no),
        },
        {
          title: "Area Code",
          dataIndex: "asset_code",
          key: "asset_code",
          sorter: (a, b) => a.asset_code.localeCompare(b.asset_code),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Location Name",
          dataIndex: "location_name",
          key: "location_name",
          sorter: (a, b) => a.location_name.length - b.location_name.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Inform Date",
          render: (item) => {
            return !item.inform_date ? "-" : this.dateFormat(item.inform_date);
          },
          key: "inform_date",
          sorter: (a, b) => a.inform_date.localeCompare(b.inform_date),
        },
        {
          title: "Inform Detail",
          dataIndex: "inform_detail",
          key: "inform_detail",
          sorter: (a, b) => a.inform_detail.length - b.inform_detail.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Inform By",
          dataIndex: "who_inform_name",
          key: "who_inform_name",
          sorter: (a, b) => a.who_inform_name.length - b.who_inform_name.length,
        },
        {
          title: "Action",
          width: 300,
          align: "center",
          render: (item) => (
            <div>
              {this.state.active === 1 ? (
                <>
                  <button
                    className="btn btn-secondary"
                    onClick={() => this.CancelInfo(item)}
                  >
                    Cancel
                  </button>
                  {item.flagAuto === 1 ? (
                    <button
                      className="btn btn-secondary"
                      style={{
                        color: "#000f9f",
                        background: "#e8cd00",
                        border: "1px solid #e8cd00",
                      }}
                      onClick={() => this.CreateJobAuto(item)}
                    >
                      Create Job Auto
                    </button>
                  ) : (
                    <button
                      className="btn btn-secondary"
                      style={{
                        color: "#000f9f",
                        background: "#e8cd00",
                        border: "1px solid #e8cd00",
                      }}
                      onClick={() => this.CreateJob(item)}
                    >
                      Create Job
                    </button>
                  )}
                </>
              ) : null}
              {this.state.active === 0 ? (
                <button
                  className="btn btn-success"
                  onClick={() => this.onApprove(item)}
                >
                  <img
                    src={Api.absoluteUrl("/icon/approve.svg")}
                    className="mr-2"
                  />
                  Approve
                </button>
              ) : null}
            </div>
          ),
        },
      ],
      columns_no_actions: [
        {
          title: "Inform No.",
          key: "inform_job_no",
          render: (item) => (
            <a
              // href={null}
              className="c-blue text-underline"
              onClick={() => setCookies(item, this.state.active + 1)}
            >
              {item.inform_job_no}
            </a>
          ),
          sorter: (a, b) => a.inform_job_no.localeCompare(b.inform_job_no),
        },
        {
          title: "Area Code",
          dataIndex: "asset_code",
          key: "asset_code",
          sorter: (a, b) => a.asset_code.localeCompare(b.asset_code),
          ellipsis: {
            showTitle: false,
          },
        },
        {
          title: "Location Name",
          dataIndex: "location_name",
          key: "location_name",
          sorter: (a, b) => a.location_name.length - b.location_name.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Inform Date",
          render: (item) => {
            return !item.inform_date ? "-" : this.dateFormat(item.inform_date);
          },
          key: "inform_date",
          sorter: (a, b) => a.inform_date.localeCompare(b.inform_date),
        },
        {
          title: "Inform Detail",
          dataIndex: "inform_detail",
          key: "inform_detail",
          sorter: (a, b) => a.inform_detail.length - b.inform_detail.length,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          ),
        },
        {
          title: "Inform By",
          dataIndex: "who_inform_name",
          key: "who_inform_name",
          sorter: (a, b) => a.who_inform_name.length - b.who_inform_name.length,
        },
      ],
      data: [],
      original_data: [],
      status_cancel: false,
      total: [],
      display_load: false,
      loading: true,
      filterTable: null,
      form: {},
      master_reject: [],
      text_modal: "",
      modalstatus: false,
      loadingPage: false
    };
  }
  async componentDidMount() {
    document.title = this.state.title;
    // localStorage.clear();
    localStorage.removeItem("editjob");
    localStorage.removeItem("StatusLocal");
    localStorage.removeItem("informDetail");
    localStorage.removeItem("active");

    const sql_where = [
      "and is_active = 1  and is_approve = 0 and is_create = 0",
      "and is_active = 1  and is_approve = 1 and is_create = 0",
      "and is_active = 1  and is_approve = 1 and is_create = 1",
      "and is_create = 0 and is_active = 1  and is_approve = 2",
    ];

    const ListInform = await Api.post("tab_list_inform", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      // create_by:  Cookies.get("username"),
      v_where: "and is_active = 1  and is_approve = 0 and is_create = 0",
    });
    const selectReject = await Api.post("get_servicemareasonstoptime_v2", {
      company_id: Cookies.get("company_id"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      ma_reason: "REJECT",
    });

    this.oncount();
    this.setState({
      data: ListInform.data.data.result,
      original_data: ListInform.data.data.result,
      display_load: true,
      loadingPage: true , 
      loading: false,
      master_reject: selectReject.data.data.serult_service_reason,
    });
  }
  onView(id) {
    this.setState({
      visible: true,
      asset_id: id,
    });
  }
  oncount = async () => {
    const total_inform = await Api.post("tab_count_inform_data", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      datess: null,
    });
    this.setState({
      total: total_inform.data.data.result,
    });
  };
  renderModal() {
    const { visible, asset_id } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b font16 c-blue text-uppercase">
            Asset ID : {asset_id}
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal-large"
      >
        <div className="row">
          <div className="col-6">
            <div className="mb-3">
              <img
                src={Api.absoluteUrl("/icon/notifications_white.svg")}
                className="img-fluid"
                alt=""
              />
            </div>

            <div className="position-relative" style={{ height: "250px" }}>
              <Map
                center={{
                  lat: 13.764101,
                  lng: 100.54234,
                }}
                zoom={10}
              />
            </div>

            <div className="d-flex justify-content-between">
              <div>
                <span className="font-thai-b font18 d-block">Lat / Long</span>
                <span className="font-thai-sb font18 c-blue">
                  13.764101 / 100.54234
                </span>
              </div>
              <a
                target="_blank"
                href={
                  "https://maps.google.com/?q=" + 13.764101 + "," + 100.54234
                }
              >
                <img
                  src={Api.absoluteUrl("/icon/google_map.svg")}
                  className="mr-2"
                />
                <span className="font-thai-b font16 c-blue text-underline">
                  Google map
                </span>
              </a>
            </div>
          </div>
          <div className="col-6">
            <div className="full-detail-job-des">
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Code</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Name</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Group Type</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Type</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Sub Type</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Model Number</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Social Number</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Date Install</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Warranty</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-red">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">MA Period</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Type Screen</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Format</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Resolution</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Eyeball / Month</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Width</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Length</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Height</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Sqm</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 text-center">
          <button
            type="reset"
            onClick={() => this.setState({ visible: false })}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>
      </Modal>
    );
  }
  setDataTab = async (index) => {
    const sql_where = [
      "and is_active = 1  and is_approve = 0 and is_create = 0",
      "and is_active = 1  and is_approve = 1 and is_create = 0",
      "and is_active = 1  and is_approve = 1 and is_create = 1",
      "and is_create = 0 and is_active = 1  and is_approve = 2",
    ];
    const ListInform = await Api.post("tab_list_inform", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      // create_by: Cookies.get("username"),
      v_where: sql_where[index],
    });
    console.log(ListInform);
    this.oncount();
    this.setState({
      filterTable: null,
      data: ListInform.data.data.result,
      active: index,
    });
  };

  dateFormat(item) {
    return !item ? "-" : moment(item).format("DD/MM/YYYY HH:mm");
  }

  search = (value) => {
    const { data, tab } = this.state;
    var index = 0;
    var setdata = [];
    var obj = {};
    for (let i = 0; i < data.length; i++) {
      for (const [key, value] of Object.entries(data[i])) {
        // if (`${key}` !== "inform_job_id") {
        if (value == null || value == undefined) {
          obj[`${key}`] = "-";
        } else {
          obj[`${key}`] = `${value}`;
        }
        // }
      }
      setdata.push(obj);
      setdata.push(index++);
      obj = {};
    }

    const filterTable = setdata.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );

    this.setState({ filterTable });
  };

  CreateJob = async (item) => {
    localStorage.setItem("informDetail", JSON.stringify(item));
    localStorage.setItem("StatusLocal", 2);
    setTimeout(function () {
      window.location.assign("/MaxiOperation/editjob");
    }, 1000);
  };
  CreateJobAuto = async (item) => {
    this.setState({
      loadingPage: false
    })
    const cancelInform = await Api.post("create_oper_job_by_inform", [{
      "inform_job_id": item.inform_job_id,
      "inform_job_no": item.inform_job_no,
      "emp_id":  Cookies.get("userId")
    }]);

    if (cancelInform.data.result.code === "P") {
      this.setState({
        loadingPage: true
      })
      this.setState({
        text_modal: "Create Inform",
        modalstatus: true,
      });
    }
    else{
      alert("ไม่สามารถสร้างงานแบบอัตโนมัติได้ !!!");
      this.setState({
        loadingPage: true
      })
    }

  };

  CancelInform = async (item) => {
    const cancelInform = await Api.post("tab_update_inform_approve", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      inform_job_id: item.inform_job_id,
      flag_approve: 2,
      create_by: Cookies.get("username"),
      service_ma_reason_id: this.state.form["Reason"],
      approve_remark: this.state.form["remark"],
    });
    if (cancelInform.data.result.code === "P") {
      this.setState({
        text_modal: "Cancel Inform",
        modalstatus: true,
      });
    }
  };
  onApprove = async (item) => {

    this.setState({
      loadingPage : false
    })
    // console.log(item);
    const tab_update_inform_approve = await Api.post(
      "tab_update_inform_approve",
      {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        inform_job_id: item.inform_job_id,
        flag_approve: 1,
        create_by: Cookies.get("userId"),
      }
    );
    if (tab_update_inform_approve.data.result.code === "P") {
      this.setState({
        loadingPage : true
      })
      this.setState({
        text_modal: "Approve Inform",
        modalstatus: true,
      });
    } else {
      alert("Approve ไม่สำเร็จ");
    }
  };
  renderCancel() {
    return (
      <Modal
        title={null}
        centered
        visible={this.state.status_cancel}
        footer={null}
        closable={true}
        onCancel={() =>
          this.setState({
            status_cancel: false,
          })
        }
      >
        <div className="text-center">
          <h3 className="font-mont-sb font18 c-blue mt-3">Cancel Job</h3>
          <div className="row mt-3 mb-2">
            <div className="col-3">
              {" "}
              <span>Reason : </span>
            </div>
            <div className="col-7">
              <Select
                style={{ border: "0px", textAlign: "left" }}
                placeholder="Select a Reason"
                className="inputfile"
                onChange={(value) => (this.state.form["Reason"] = value)}
              >
                {this.state.master_reject.map((item, index) => (
                  <Select.Option value={item.service_ma_reason_id} key={index}>
                    {item.service_ma_reason_desc}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              {" "}
              <span>Remark : </span>
            </div>
            <div className="col-7">
              <textarea
                style={{ width: "100%", height: "60px" }}
                name="inform_remark"
                onChange={(e) => (this.state.form["remark"] = e.target.value)}
              ></textarea>
            </div>
          </div>
          <button
            onClick={() => this.CancelInform()}
            className="btn btn-secondary"
          >
            OK
          </button>
        </div>
      </Modal>
    );
  }
  render() {
    const { title, active, tab, filterTable } = this.state;

    // console.log(current_option);
    return (
      <LayoutOperation active={3}>
        {this.renderModal()}
        {this.renderCancel()}
        {this.state.modalstatus ? (
          <ModalSuccess
            status={this.state.text_modal}
            path_location="/MaxiOperation/inform_problem_list"
          />
        ) : null}
       <Spin spinning={!this.state.loadingPage} size="large" style={{marginTop: "16%"}}>
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/menu_inform_white.svg")}
                  className="mr-2"
                  style={{ width: "22px", height: "22px" }}
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                  {title}
                </h2>
              </div>
              <div className="col-6">
                <div className="row justify-content-center">
                  <div className="col-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b c-white font14"></span>
                    </div>
                  </div>
                  <div className="col-3 offset-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b c-white font14"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 text-right">
                <Link to="/" className="c-white font-mont-m font12">
                  <img
                    src={Api.absoluteUrl("/icon/map.svg")}
                    className="mr-1"
                  />
                  Map
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="my-2 d-flex align-items-center justify-content-between row">
              <div className="col-12">
                <div className="d-flex row">
                  {/* <div className="col-auto">
                    <Input.Group compact>
                      <Select placeholder="Asset Group Type"></Select>
                      <Select placeholder="Asset Type"></Select>
                    </Input.Group>
                  </div> */}
                  <div className="col-10">
                    <Input.Group compact>
                      {/*   <Select
                        value={current_option}
                        style={{ width: "180px" }}
                        onChange={this.handleOptionSearch}
                      >
                        {options.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.text}
                          </Option>
                        ))}
                      </Select> */}

                      <Input.Search
                        placeholder="Search"
                        onSearch={this.search}
                        style={{ width: "335px" }}
                        enterButton
                      />
                    </Input.Group>
                  </div>
                  <div className="col-2">
                    <a
                      href={null}
                      className="btn btn-warning"
                      style={{ float: "right" }}
                      onClick={() => setCookies(null, 0)}
                    >
                      <img
                        src={Api.absoluteUrl("/icon/add_job.svg")}
                        width="14"
                        className="mr-2"
                      />
                      Inform Problem
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-table-ma">
              {/* <ul className="nav">
                {tab.map((item, index) => <li key={index} className="nav-item font12 font-mont-sb mr-1">
                    <a className={active === index ? "nav-link active" : "nav-link"} onClick={() => this.setState({ active: index })}>{item.text}</a>
                </li>)}
            </ul> */}
              <ul className="nav">
                {tab.map((item, index) => (
                  <li key={index} className="nav-item font12 font-mont-sb mr-1">
                    <a
                      className={
                        active === index ? "nav-link active" : "nav-link"
                      }
                      onClick={() => this.setDataTab(index)}
                    >
                      {item.text}
                      {" ("}
                      {this.state.total.length === 0
                        ? 0
                        : this.state.total[index].total}
                      {") "}
                    </a>
                  </li>
                ))}
              </ul>
              <div style={{ padding: "5px" }}>
                <Table
                  loading={this.state.loading}
                  columns={
                    this.state.active === 0 || this.state.active === 1
                      ? this.state.columns
                      : this.state.columns_no_actions
                  }
                  rowKey="inform_job_id"
                  dataSource={
                    filterTable == null ? this.state.data : filterTable
                  }
                  size="middle"
                />
              </div>
            </div>
          </div>
        </div>
        </Spin>

      </LayoutOperation>
    );
  }
}

export default InformList;
